import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { HeaderComponent } from '@app/public/header/header.component';
import { FooterComponent } from '@app/public/footer/footer.component';

@Component({
  selector: 'app-terms-conditions',
  standalone: true,
  imports: [CommonModule, RouterLink, HeaderComponent, FooterComponent],
  template: `
    <app-header></app-header>
    <main class="legal-page">
      <div class="container">
        <div class="legal-content">
          <h1>Conditions Générales d'Utilisation</h1>
          <p class="last-updated">Dernière mise à jour : 1 Juin 2025</p>

          <section>
            <h2>1. Acceptation des conditions</h2>
            <p>
              En accédant ou en utilisant l'application Zero-Waste, vous
              acceptez d'être lié par ces Conditions Générales d'Utilisation. Si
              vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre
              application.
            </p>
          </section>

          <section>
            <h2>2. Description du service</h2>
            <p>
              Zero-Waste est une plateforme qui met en relation des commerçants
              proposant des invendus alimentaires à prix réduits avec des
              consommateurs souhaitant lutter contre le gaspillage alimentaire
              tout en réalisant des économies.
            </p>
          </section>

          <section>
            <h2>3. Inscription et compte</h2>
            <p>
              Pour utiliser certaines fonctionnalités de notre application, vous
              devez créer un compte. Vous êtes responsable de :
            </p>
            <ul>
              <li>
                Fournir des informations exactes et complètes lors de
                l'inscription
              </li>
              <li>Maintenir la confidentialité de votre mot de passe</li>
              <li>Toutes les activités qui se produisent sous votre compte</li>
            </ul>
            <p>
              Nous nous réservons le droit de suspendre ou de résilier votre
              compte si nous soupçonnons une utilisation frauduleuse ou abusive.
            </p>
          </section>

          <section>
            <h2>4. Utilisation du service</h2>
            <h3>4.1 Pour les consommateurs</h3>
            <p>En tant que consommateur, vous pouvez :</p>
            <ul>
              <li>Parcourir les offres disponibles</li>
              <li>Réserver des paniers d'invendus</li>
              <li>Récupérer vos commandes aux horaires indiqués</li>
              <li>Évaluer votre expérience</li>
            </ul>

            <h3>4.2 Pour les commerçants</h3>
            <p>En tant que commerçant, vous pouvez :</p>
            <ul>
              <li>Créer et gérer votre profil professionnel</li>
              <li>Publier des offres d'invendus</li>
              <li>Définir les prix, descriptions et horaires de collecte</li>
              <li>Gérer vos réservations</li>
            </ul>
          </section>

          <section>
            <h2>5. Contenu et comportement</h2>
            <p>Vous acceptez de ne pas :</p>
            <ul>
              <li>Publier du contenu faux, trompeur, offensant ou illégal</li>
              <li>Utiliser l'application pour des activités illégales</li>
              <li>Tenter de contourner les fonctionnalités de sécurité</li>
              <li>Perturber le fonctionnement normal de l'application</li>
            </ul>
          </section>

          <section>
            <h2>6. Transactions et paiements</h2>
            <p>
              Zero-Waste facilite les transactions entre commerçants et
              consommateurs. Nous ne sommes pas responsables de la qualité des
              produits proposés. Les paiements sont traités par des prestataires
              de services de paiement tiers et sont soumis à leurs propres
              conditions.
            </p>
          </section>

          <section>
            <h2>7. Propriété intellectuelle</h2>
            <p>
              Tous les droits de propriété intellectuelle relatifs à
              l'application Zero-Waste (y compris le logo, les textes, les
              images, etc.) sont la propriété de Zero-Waste ou de ses concédants
              de licence. Vous ne pouvez pas utiliser, copier ou distribuer ce
              contenu sans autorisation.
            </p>
          </section>

          <section>
            <h2>8. Limitation de responsabilité</h2>
            <p>
              Zero-Waste fournit l'application "telle quelle" et "selon
              disponibilité". Nous ne garantissons pas que l'application sera
              ininterrompue, sécurisée ou exempte d'erreurs. Dans la mesure
              permise par la loi, nous déclinons toute responsabilité pour les
              dommages indirects, spéciaux, consécutifs ou punitifs.
            </p>
          </section>

          <section>
            <h2>9. Modifications des conditions</h2>
            <p>
              Nous pouvons modifier ces conditions à tout moment. Les
              modifications entreront en vigueur dès leur publication. Votre
              utilisation continue de l'application après la publication des
              modifications constitue votre acceptation des nouvelles
              conditions.
            </p>
          </section>

          <section>
            <h2>10. Résiliation</h2>
            <p>
              Vous pouvez résilier votre compte à tout moment. Nous pouvons
              également suspendre ou résilier votre accès à l'application si
              vous violez ces conditions.
            </p>
          </section>

          <section>
            <h2>11. Droit applicable</h2>
            <p>
              Ces conditions sont régies par le droit français. Tout litige
              relatif à ces conditions sera soumis à la compétence exclusive des
              tribunaux de Paris, France.
            </p>
          </section>

          <section>
            <h2>12. Nous contacter</h2>
            <p>
              Si vous avez des questions concernant ces conditions, veuillez
              nous contacter à :
            </p>
            <p>
              Zero-Waste<br />
              42 Rue de l'Écologie<br />
              75001 Paris, France<br />
              <a href="mailto:legal@zero-waste.com">legal&#64;zero-waste.com</a>
            </p>
          </section>

          <div class="back-link">
            <a [routerLink]="['/']">← Retour à l'accueil</a>
          </div>
        </div>
      </div>
    </main>
    <app-footer></app-footer>
  `,
  styles: [
    `
      .legal-page {
        padding: 120px 0 60px;
        background-color: #f9f9f9;
      }

      .legal-content {
        background-color: var(--white);
        padding: 40px;
        border-radius: 10px;
        box-shadow: var(--shadow);
        max-width: 900px;
        margin: 0 auto;
      }

      h1 {
        color: var(--primary-dark);
        margin-bottom: 10px;
        font-size: 2.5rem;
      }

      .last-updated {
        color: var(--light-text);
        font-style: italic;
        margin-bottom: 30px;
      }

      section {
        margin-bottom: 30px;
      }

      h2 {
        color: var(--primary-color);
        margin-bottom: 15px;
        font-size: 1.5rem;
      }

      h3 {
        color: var(--primary-dark);
        margin: 15px 0 10px;
        font-size: 1.2rem;
      }

      p,
      ul {
        margin-bottom: 15px;
        line-height: 1.6;
      }

      ul {
        padding-left: 20px;
      }

      li {
        margin-bottom: 8px;
      }

      a {
        color: var(--primary-color);
        text-decoration: none;
      }

      a:hover {
        text-decoration: underline;
      }

      .back-link {
        margin-top: 40px;
        padding-top: 20px;
        border-top: 1px solid #eee;
      }

      .back-link a {
        display: inline-block;
        font-weight: 500;
      }

      @media (max-width: 768px) {
        .legal-page {
          padding: 100px 0 40px;
        }

        .legal-content {
          padding: 25px;
        }

        h1 {
          font-size: 2rem;
        }
      }
    `,
  ],
})
export class TermsConditionsComponent {}
